export var TelemetryAgentWizardSteps;
(function (TelemetryAgentWizardSteps) {
    TelemetryAgentWizardSteps[TelemetryAgentWizardSteps["Platform"] = 0] = "Platform";
    TelemetryAgentWizardSteps[TelemetryAgentWizardSteps["Datasources"] = 1] = "Datasources";
    TelemetryAgentWizardSteps[TelemetryAgentWizardSteps["AgentDetails"] = 2] = "AgentDetails";
})(TelemetryAgentWizardSteps || (TelemetryAgentWizardSteps = {}));
export var TelemetryAgentSubjects;
(function (TelemetryAgentSubjects) {
    TelemetryAgentSubjects["AddNewCollector"] = "add-new-collector";
    TelemetryAgentSubjects["FleetManagementPage"] = "telemetry-agent-fleet-management-page";
    TelemetryAgentSubjects["FleetManagementEmptyState"] = "telemetry-agent-fleet-management-empty-state";
    TelemetryAgentSubjects["WizardPage"] = "telemetry-agent-wizard-page";
    TelemetryAgentSubjects["WizardStepHeader"] = "telemetry-agent-wizard-step-header";
    TelemetryAgentSubjects["WizardStepContainer"] = "telemetry-agent-wizard-step-container";
    TelemetryAgentSubjects["PlatformStep"] = "telemetry-agent-platform-step";
    TelemetryAgentSubjects["DatasourceCardTitle"] = "telemetry-agent-datasource-card-title";
    TelemetryAgentSubjects["DatasourcesStep"] = "telemetry-agent-datasources-step";
    TelemetryAgentSubjects["AgentDetailsStep"] = "telemetry-agent-agent-details-step";
    TelemetryAgentSubjects["InstallationPage"] = "telemetry-agent-installation-page";
    TelemetryAgentSubjects["InstallationPageInstructionsTitle"] = "telemetry-agent-installation-page-instructions-title";
    TelemetryAgentSubjects["Platform"] = "platform";
    TelemetryAgentSubjects["IntegrationSelector"] = "integration-selector";
    TelemetryAgentSubjects["Subtype"] = "subtype";
    TelemetryAgentSubjects["ConfigCard"] = "ConfigCard";
    TelemetryAgentSubjects["TelemetryCard"] = "telemetry-card";
    TelemetryAgentSubjects["TelemetryTitle"] = "telemetry-title";
    TelemetryAgentSubjects["DatasourceCard"] = "datasource-card";
    TelemetryAgentSubjects["TelemetryToggle"] = "telemetry-toggle";
    TelemetryAgentSubjects["DatasourceToggle"] = "datasource-toggle";
    TelemetryAgentSubjects["AddDatasource"] = "add-datasource";
    TelemetryAgentSubjects["RemoveDatasource"] = "remove-datasource";
    TelemetryAgentSubjects["CollectorNameInput"] = "collector-name-input";
    TelemetryAgentSubjects["CollectorDescriptionInput"] = "collector-description-input";
    TelemetryAgentSubjects["StepTitle"] = "step-title";
    TelemetryAgentSubjects["InformationSection"] = "notification-section";
    TelemetryAgentSubjects["InstallationNextActionCard"] = "installation-next-action-card";
    TelemetryAgentSubjects["InstallationNextActions"] = "installation-next-actions";
    TelemetryAgentSubjects["InstallationWaitingForDataCard"] = "installation-waiting-for-data-card";
    TelemetryAgentSubjects["InstallationKibanaCard"] = "installation-kibana-card";
    TelemetryAgentSubjects["InstallationKubernetesCard"] = "installation-kubernetes-card";
    TelemetryAgentSubjects["InstallationTracingCard"] = "installation-tracing-card";
    TelemetryAgentSubjects["InstallationSpmCard"] = "installation-spm-card";
    TelemetryAgentSubjects["InstallationCtaCard"] = "installation-Cta-card";
    TelemetryAgentSubjects["InstallationMetricsCard"] = "installation-metrics-card";
    TelemetryAgentSubjects["InstallationConnectionStatus"] = "installation-connection-status";
    TelemetryAgentSubjects["InstallationBundleNotification"] = "installation-bundle-notification";
    TelemetryAgentSubjects["AccountsTitle"] = "accounts-title";
    TelemetryAgentSubjects["AccountSelect"] = "account-select";
    TelemetryAgentSubjects["BackStep"] = "agent-wizard-back";
    TelemetryAgentSubjects["NextStep"] = "agent-wizard-next";
    TelemetryAgentSubjects["CancelWizard"] = "agent-wizard-cancel";
    TelemetryAgentSubjects["InstallDashboardsButton"] = "install-dashboards-button";
    TelemetryAgentSubjects["InstallCommand"] = "install-command";
    TelemetryAgentSubjects["LaunchStackLink"] = "launch-stack-link";
    TelemetryAgentSubjects["AgentParamPathListRemovePath"] = "telemetry-agent-param-remove-path";
    TelemetryAgentSubjects["AgentParamStringListRemoveString"] = "telemetry-agent-string-list-param-remove-path";
    TelemetryAgentSubjects["AgentParamKeyValueRemovePair"] = "telemetry-agent-param-remove-key-value";
    TelemetryAgentSubjects["AgentParamMultilinePatternRemove"] = "telemetry-agent-multiline-pattern-remove";
    TelemetryAgentSubjects["AgentFleetTable"] = "telemetry-agent-fleet-table";
    TelemetryAgentSubjects["SummaryAgentName"] = "telemetry-agent-summary-agent-name";
    TelemetryAgentSubjects["SummaryAgentDescription"] = "telemetry-agent-summary-agent-description";
    TelemetryAgentSubjects["SummaryPlatform"] = "telemetry-agent-summary-platform";
    TelemetryAgentSubjects["SummarySubtype"] = "telemetry-agent-summary-subtype";
    TelemetryAgentSubjects["SummaryDatasourceTelemetries"] = "telemetry-agent-summary-datasource-telemetries";
    TelemetryAgentSubjects["SummaryDatasources"] = "telemetry-agent-summary-datasources";
    TelemetryAgentSubjects["SummaryLogsAccount"] = "telemetry-agent-logs-account";
    TelemetryAgentSubjects["SummaryMetricsAccount"] = "telemetry-agent-metrics-account";
    TelemetryAgentSubjects["SummaryTracingAccount"] = "telemetry-agent-tracing-account";
})(TelemetryAgentSubjects || (TelemetryAgentSubjects = {}));
//# sourceMappingURL=telemetry-agent.enum.js.map